/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import { Stack } from '@mui/material';
import { CssTextField } from 'components/select';
import { useRecoilState } from 'recoil';
import { orderPayload, isValidappSupportMailId, certCreationRequired, customDomainFieldsDiasbled } from 'pages/provisioning/virtual-service/store';
import ProvisioningStyles from 'pages/provisioning/virtual-service/style';
import InfoImg from 'components/info-img';

const AppSupportMailIdDL = () => {
    const [isTouched, setIsTouched] = React.useState(false);
    const [order, setOrder] = useRecoilState(orderPayload);
    const [, setValidEmail] = useRecoilState(isValidappSupportMailId);
    const [showHelperText, setHelperText] = React.useState(false);
    const [showHelperMsg, setHelperMsg] = React.useState('');
    const [isRequired] = useRecoilState(certCreationRequired);
    const [isDisabled] = useRecoilState(customDomainFieldsDiasbled);

    const handleValueChange = (value) => {
        if (value !== order?.appSupportMailId) {
            setOrder({
                ...order,
                appSupportMailId: value,
            });
        }
    };

    const emailValidation = () => {
        setValidEmail(true);
        setHelperText(true);
        setHelperMsg('Enter Valid email');
    };

    React.useEffect(() => {
        if (
            order?.appSupportMailId &&
            order?.appSupportMailId !== null &&
            order?.appSupportMailId !== '' &&
            order?.appSupportMailId !== undefined &&
            !/[^0-9][A-Za-z0-9.-]{3,}@pepsico.com$/i.test(order?.appSupportMailId)
        ) {
            emailValidation();
        } else if (/\s/.test(order?.appSupportMailId)) {
            emailValidation();
        } else {
            setValidEmail(false);
            setHelperText(false);
            setHelperMsg('');
        }
    }, [order?.appSupportMailId]);

    const validateInput = () => {
        let validateText = '';
        if ((isTouched && order?.isTouched && !order?.appSupportMailId) || showHelperMsg) {
            validateText = 'validate';
        } else if (isRequired && !order?.appSupportMailId) {
            validateText = 'validate1';
        }
        return validateText;
    };

    React.useEffect(() => {
        if (!order?.appSupportMailId && order?.isTouched) setIsTouched(true);
    }, [order?.appSupportMailId, order?.isTouched]);

    return (
        <Stack direction="row" spacing={1} sx={ProvisioningStyles.stack}>
            <CssTextField
                size="small"
                sx={{
                    width: (theme) => theme.spacing('100%'),
                    '& .MuiFormHelperText-root': {
                        marginTop: (theme) => theme.spacing('-2'),
                    },
                }}
                data-testid="appSupportDLtext"
                label="Application Support DL *"
                autoComplete="off"
                error={showHelperText}
                helperText={showHelperText && <span style={{ color: '#d40020' }}>{showHelperMsg}</span>}
                value={order?.appSupportMailId || ''}
                onChange={(e) => handleValueChange(e.target.value)}
                disabled={!isRequired || isDisabled}
                className={validateInput()}
            />
            <InfoImg maxWidth="450px" title="Email group or DL should be like this example format: DL - Global DevX Operations" />
        </Stack>
    );
};

export default AppSupportMailIdDL;
